<template>
  <!-- 框架 -->
  <div class="pc-laytout">
    <pc-nav></pc-nav>
    <pc-contact></pc-contact>
    <slot></slot>
    <pc-bottom></pc-bottom>
  </div>
</template>

<script>
import PcNav from '@/components/nav.vue'
import PcBottom from '@/components/bottom.vue'
import PcContact from '@/components/contact.vue'
export default {
  name: 'pc-layout',
  components: {
    PcNav,
    PcBottom,
    PcContact
  },
  props: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss"></style>
